import React from "react";
import PropTypes from "prop-types";
import logoWithLines from "assets/graphics/icons/logo-with-lines.svg";
import parlorSocialClub from "assets/graphics/icons/parlor-social-club.svg";
import { Link } from "react-router-dom";
import { Loader } from "common/components/loader/view";
import "screens/invitation/component/view.scss";

export const InvitationView = ({ isLoading, data }) => {
  return (
    <>
      <Loader isOpen={isLoading} />
      {data && (
        <main className="invitation-page">
          <div className="invitation-page__container">
            <header className="invitation-page__header invitation-page__header--mobile">
              <div className="invitation-page__logo">
                <img src={logoWithLines} alt="logo" />
              </div>
              <h1 className="invitation-page__heading">
                <span className="invitation-text">
                  {data.friend_first_name}, you’re invited <br /> to join Parlor
                </span>
                <div className="invitation-page__invited-by">
                  <p className="secondary-text">by Member {data.member_name}</p>
                </div>
              </h1>
            </header>
            <img
              className="invitation-page__full-logo"
              src={parlorSocialClub}
              alt=""
            />
            <div className="invitation-page__description-wrapper">
              <p className="secondary-text secondary-text--description">
                Parlor is a modern social club. Members enjoy a personalized
                calendar of social, cultural and professional events and an
                opportunity to connect with each other, both online and in
                person.
              </p>
            </div>
            <div className="invitation-page__button-wrapper">
              <Link to="/application/sign-up" className="join-button">
                Join Parlor
              </Link>
            </div>
          </div>
        </main>
      )}
    </>
  );
};

InvitationView.defaultProps = {
  isLoading: false,
};

InvitationView.propTypes = {
  isLoading: PropTypes.bool,
  data: PropTypes.instanceOf(Object),
};
